import { axiosClient } from "@/shared/api/axios-client";
import type { SolicitudDetalle } from "@/lib/types";
import type { DatosGeneralesInput } from "@/features/datos-generales/types";

/**
 * Endpoint de captura de datos generales · PATCH al recurso solicitud.
 * Devuelve la solicitud completa con el estado avanzado a
 * `SeleccionandoProveedor` para que el cache se hidrate al instante.
 */
export const datosGeneralesApi = {
  capturar: (solicitudId: string, body: DatosGeneralesInput) =>
    axiosClient
      .patch<SolicitudDetalle>(
        `/api/solicitudes/${solicitudId}/datos-generales`,
        body
      )
      .then((r) => r.data),
};
